const LandingPageSectionTitle = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-section-title" */ '@/app/views/client-view/landing-page/components/_shared/landing-page-section-title/landing-page-section-title.vue');
const LandingPageMobileDisplay = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-mobile-display" */ '@/app/views/client-view/landing-page/components/_shared/landing-page-mobile-display/landing-page-mobile-display.vue');

export default {
    name: 'LandingPageHealthData',
    props: {
        sectionTitle: {
            type: String,
            required: true
        },
        imageName: {
            type: String,
            required: true
        },
        sectionDescription: {
            type: String,
            required: true
        },
        screenImageNames: {
            type: Array,
            required: true
        },
        screenImageDescriptions: {
            type: Array,
            required: true
        }
    },
    components: {
        LandingPageSectionTitle,
        LandingPageMobileDisplay
    }
}